import { useRouter } from 'next/router';

import { STATIC_ADDRESS, WEB_URL } from '~constant/env';
import NudgeLoginDialog from '~features/company/NudgeLoginDialog';
import useGetCompanyCultureReviewQuery from '~hooks/query/company/useCompanyCultureReview';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useMedia from '~hooks/useMedia';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { useRouterQuery } from '~hooks/useRouterQuery';

import { ChartSectionWrapper } from '../style';
import * as S from './style';

function NudgeLoginSection() {
  const router = useRouter();
  const companyHash = useRouterQuery('companyId');
  const { isMobile } = useMedia();
  const { data: culturlReview } = useGetCompanyCultureReviewQuery(companyHash);
  const { data: companyInfo } = useGetCompanyInfo(companyHash);
  const { isActiveUser } = useGetMyInfoQuery();
  const moveOneIdPage = useMoveOneIdPage();

  const handleClick = () => {
    if (isActiveUser) {
      return router.push(
        `/review/culture?companyHash=${companyHash}&beforeUrl=${WEB_URL}${router.asPath}#company-review-chart`,
      );
    }
    moveOneIdPage({
      beforeUrl: `${WEB_URL}${router.asPath}#company-review-chart`,
      messageKey: 'kreditjob_company_bookmark_title',
    });
  };

  return (
    <ChartSectionWrapper
      onClick={handleClick}
      data-attribute-id='company__review__write__click'
      data-is-review-exist={culturlReview?.isAllEmpty ? 'false' : 'true'}
      data-company-hash={companyInfo?.PK_NM_HASH}
      data-company-name={companyInfo?.name}
      data-review-type={'culture'}
      data-is-blur='true'>
      <NudgeLoginDialog
        inlineCss={S.cssNudgeDialog}
        message={
          <>
            {companyInfo?.name}의<br />
            조직문화가 궁금하다면?
          </>
        }
        buttonText='리뷰하기'
      />
      <S.VideoWrapper autoPlay loop muted playsInline width='100%'>
        <source
          key='/images/barchart-culture.webm'
          src={`${STATIC_ADDRESS}/images/barchart-culture${isMobile ? '-m' : ''}.webm`}
          type='video/webm'
        />
        <source
          key='/images/barchart-culture.mp4'
          src={`${STATIC_ADDRESS}/images/barchart-culture${isMobile ? '-m' : ''}.mp4`}
          type='video/mp4'
        />
      </S.VideoWrapper>
    </ChartSectionWrapper>
  );
}

export default NudgeLoginSection;
